<template>
  <div class="content-custom-pj">
    <h4><v-icon name="user" class="icon-custom1"></v-icon> Profile</h4>
    <b-alert show variant="dark">
      <b-card
        header="ข้อมูลผู้ใช้งานระบบ"
        align="left"
        text-variant="dark"
        bg-variant="light"
      >
        <b-card-text v-if="$store.get('systems@LoginStatus')">
          <b-row>
            <b-col cols lg="3">
              <h4>
                <b-badge variant="success"
                  >UserID :
                  {{ $store.get("systems@LoginData").UserId }}</b-badge
                >
              </h4>
            </b-col>
            <b-col cols lg="3">
              <h4>
                <b-badge variant="success"
                  >Name :
                  {{ $store.get("systems@LoginData").userName }}</b-badge
                >
              </h4>
            </b-col>
            <b-col cols lg="3">
              <h4>
                <b-badge variant="success"
                  >ตำแหน่ง :
                  {{ $store.get("systems@LoginData").entryposition }}</b-badge
                >
              </h4>
            </b-col>
            <b-col cols lg="3">
              <h4>
                <b-badge variant="success"
                  >กลุ่ม :
                  {{ $store.get("systems@LoginData").groupname }}</b-badge
                >
              </h4>
            </b-col>
          </b-row>
          <hr />
          <b-row>
            <b-col>
              <h4>
                <b-badge variant="danger">User Right :</b-badge>
              </h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-badge
                variant="warning"
                style="margin-right:4px;"
                v-for="(item, index) in $store.get('systems@LoginData')
                  .accessright"
                v-bind:key="item.id"
                >{{
                  index +
                    1 +
                    "." +
                    item.modul +
                    " | " +
                    pjFunctionsFc.NulltoStr(item.rights)
                }}</b-badge
              >
            </b-col>
          </b-row>

          <hr />
          <b-row>
            <b-col>
              <h4>
                <b-badge variant="danger">User Right HOSxP :</b-badge>
              </h4>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-badge
                variant="warning"
                style="margin-right:4px;"
                v-for="(item, index) in $store.get('systems@LoginData')
                  .hos_accessright"
                v-bind:key="item.id"
                >{{ index + 1 + "." + pjFunctionsFc.NulltoStr(item) }}</b-badge
              >
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
    </b-alert>
  </div>
</template>

<script>
import { Component, Vue, options } from "vue-property-decorator";
import store from "@/store/store";
import axios from "axios";
import VueAxios from "vue-axios";
import pjFunctions from "@/functions/pjFunctions";

@Component({
  component: {
    store,
    axios,
    VueAxios,
    pjFunctions
  },
  data() {
    return {
      show: false,
      pjFunctionsFc: null
    };
  },
  mounted() {},
  created() {
    this.pjFunctionsFc = pjFunctions.methods;
    this.startProfile();
  },
  methods: {
    startProfile() {
      if (
        !this.$store.get("systems@LoginData") ||
        this.$store.get("systems@LoginData") == "undefined" ||
        this.$store.get("systems@LoginData") == undefined ||
        this.$store.get("systems@LoginData") == null
      ) {
        // this.$router.push({
        //  path: "/"
        // });
      }
    }
  }
})
export default class LoginHOSxP extends Vue {}
</script>


<style lang="scss">
</style>
